
export enum QueryOperator {
    Equal = '_eq_',
    NotEquals = '_ne_',
    GreaterThan = '_gt_',
    GreaterThanOrEqual = '_goe_',
    LessThan = '_lt_',
    LessThanOrEqual = '_loe_',
    Like = '_like_',
    Contain = '_contain_' ,
    Between = '_between_',
    IsNull = '_isn_',
    IsNotNull = '_isnon_',
    EqualDay = '_eqd_',
    EqualMonth = '_eqm_',
    EqualYear = '_eqy_',
    Split = ',',
    Empty = '',
    Slash = '/',
    PageParam = 'page',
    SizeParam = 'size',
    QueryParam = 'q',
    SortParam = 'sort',
    SearchName = 'searchName',
    Action = 'action',
    in = '_in()'
}



// WEBPACK FOOTER //
// ./src/app/shared/_utils/services/query-operator.enum.ts